import { render } from "./ShowMailDetails.vue?vue&type=template&id=df627636"
import script from "./ShowMailDetails.vue?vue&type=script&lang=js"
export * from "./ShowMailDetails.vue?vue&type=script&lang=js"

import "./ShowMailDetails.vue?vue&type=style&index=0&id=df627636&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__